import { BrowserRouter, Route, Routes, useNavigate } from "react-router";

import { UIProvider } from "@/context/UIProvider";

// import HomePage from "@/pages/HomePage";
// import InsightsPage from "@/pages/InsightsPage";
import StudyPage from "@/pages/StudyPage";
import StudyHomePage from "@/pages/StudyHomePage";
import NotFoundPage from "@/pages/NotFoundPage";

import { ThemeToggle } from "@/components/ThemeToggle";
import { Logo } from "@shared/components/Logo";

export function Nav() {
  const navigate = useNavigate();
  return (
    <nav
      className="px-6 py-4 border-b border-neutral-200 dark:border-neutral-800
                 sticky z-10 top-0 bg-white dark:bg-neutral-950
                 shadow-xl shadow-black/3 dark:shadow-black/30"
    >
      <button onClick={() => navigate("/")}>
        <Logo />
      </button>
    </nav>
  );
}

function DevBanner() {
  const env = import.meta.env.VITE_DEPLOY_ENV;
  if (env === "prod") return null;

  return (
    <div className="w-full text-center px-6 py-3 text-sm bg-purple-100 dark:bg-purple-950/50">
      <span
        className="inline-flex px-2 py-0.5 rounded-md text-xs font-semibold
                   bg-purple-300 dark:bg-purple-900 relative -top-px mr-2"
      >
        Work in progress
      </span>
      You are currently using a development instance of the Chat Upload Portal. Please reach out to{" "}
      <a className="underline cursor-pointer" href="mailto:dair@childmind.org">
        dair@childmind.org
      </a>{" "}
      with any issues or feedback.
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <UIProvider>
        <div className="w-full flex flex-col min-h-screen">
          {/* <Nav /> */}
          <DevBanner />
          <Routes>
            <Route path="/" element={<StudyHomePage />} />
            {/* {import.meta.env.VITE_DEPLOY_ENV !== "prod" && ( */}
            {/*   <Route path="/" element={<HomePage />} /> */}
            {/* )} */}
            {/* {import.meta.env.VITE_DEPLOY_ENV !== "prod" && ( */}
            {/*   <Route path="/insights" element={<InsightsPage />} /> */}
            {/* )} */}
            <Route path="/study/:id" element={<StudyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <ThemeToggle />
        </div>
      </UIProvider>
    </BrowserRouter>
  );
}

export default App;
